import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const LocationContext = createContext({
  location: "gading-serpong",
  setLocation: () => {},
  locations: [],
});

const STORAGE_KEY = "kulintara_location";

export const LocationProvider = ({ children }) => {
  const [locations, setLocations] = useState([]);
  const [location, setLocationState] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem(STORAGE_KEY) || "gading-serpong";
    }
    return "gading-serpong";
  });

  useEffect(() => {
    api.get("/locations").then(r => setLocations(r.data)).catch(() => {});
  }, []);

  const setLocation = (slug) => {
    setLocationState(slug);
    localStorage.setItem(STORAGE_KEY, slug);
  };

  return (
    <LocationContext.Provider value={{ location, setLocation, locations }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => useContext(LocationContext);
